/** Brand inference from product titles, category labels and introductions.
 *  Pure module — safe to import from both browser code and build scripts. */

// Extra category mapping for Tallivo category names.
const BRANDS: Record<string, RegExp> = {
  yaphene: /\byaphene\b/i, marapa: /\bmarapa\b/i, nezer: /\bnezer\b/i,
  flauriel: /\bflauriel\b/i, calume: /\bcalum[eé]\b/i, herbz: /\bherbz\b/i,
};

export const BRAND_DISPLAY: Record<string, string> = {
  yaphene: "Yaphene", marapa: "MARAPA", nezer: "NEZER",
  flauriel: "Flauriel", calume: "Calumé", herbz: "Herbz",
};

export function brandMatches(brand: string, labels: string): boolean {
  return BRANDS[brand]?.test(labels) ?? false;
}

export function inferBrand(title: string, categories: string[], description: string): string | undefined {
  const labels = `${title} ${categories.join(" ")}`;
  const explicit = Object.entries(BRANDS).find(([, re]) => re.test(labels));
  if (explicit) return explicit[0];
  // The introduction describes the product itself; later routine suggestions can name other brands.
  const intro = description.split(/Why |Hero ingredients:|How to use:/i)[0];
  const described = Object.entries(BRANDS).find(([, re]) => re.test(intro));
  if (described) return described[0];
  if (/beard|aftershave|razor bump|clear cut|cool & calm/i.test(labels)) return "nezer";
  if (/cafe caribe/i.test(labels)) return "marapa";
  if (/hair|shampoo|scalp|conditioner|body|shower|deodorant|repell[ae]nt/i.test(labels)) return "yaphene";
  if (/face|facial|skin care|skincare|eye cream/i.test(labels)) return "marapa";
  if (/candle|diffuser/i.test(labels)) return "calume";
  if (/condiment|chutney|sauce|seasoning|dressing|jam|jelly|wine|brandy/i.test(labels)) return "flauriel";
  return undefined;
}
